import { useState } from 'react';
import useLocalStorage from '@/hooks/useLocalStorage';
import { defaultStoreInfo, type StoreInfo } from '@/mocks/adminData';

function StoreInfoPage() {
  const [info, setInfo] = useLocalStorage<StoreInfo>('admin_store_info', defaultStoreInfo);
  const [savedFlash, setSavedFlash] = useState(false);

  const update = (partial: Partial<StoreInfo>) => setInfo((prev) => ({ ...prev, ...partial }));

  const handleSave = () => { setSavedFlash(true); setTimeout(() => setSavedFlash(false), 2000); };

  const Field = ({ label, value, onChange, textarea = false }: { label: string; value: string; onChange: (v: string) => void; textarea?: boolean }) => (
    <div>
      <label className="block text-xs font-medium text-foreground-700 mb-1.5">{label}</label>
      {textarea ? (
        <textarea value={value} onChange={(e) => { if (e.target.value.length <= 500) onChange(e.target.value); }} rows={3} className="w-full px-3 py-2.5 rounded-lg text-sm border border-background-300 bg-white text-foreground-800 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent resize-none" />
      ) : (
        <input type="text" value={value} onChange={(e) => onChange(e.target.value)} className="w-full px-3 py-2.5 rounded-lg text-sm border border-background-300 bg-white text-foreground-800 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent" />
      )}
    </div>
  );

  return (
    <div className="p-4 md:p-6 lg:p-8">
      {savedFlash && (
        <div className="fixed top-4 right-4 z-50 px-4 py-2.5 rounded-lg bg-green-50 border border-green-200 text-green-700 text-sm font-medium shadow-sm">
          <i className="ri-check-line mr-1.5" />Alterações salvas com sucesso.
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">Informações da loja</h1>
          <p className="text-sm text-foreground-500 mt-1">Gerencie os dados de contato e endereço.</p>
        </div>
        <button type="button" onClick={handleSave} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-primary-600 text-white text-sm font-medium hover:bg-primary-700 transition-colors whitespace-nowrap">
          <i className="ri-save-line" />Salvar alterações
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-background-200 p-5">
          <h2 className="font-heading text-base font-semibold text-foreground-900 mb-4">Dados básicos</h2>
          <div className="space-y-4">
            <Field label="Nome da loja" value={info.storeName} onChange={(v) => update({ storeName: v })} />
            <Field label="E-mail" value={info.email} onChange={(v) => update({ email: v })} />
            <Field label="Instagram" value={info.instagram} onChange={(v) => update({ instagram: v })} />
            <Field label="WhatsApp principal" value={info.whatsapp} onChange={(v) => update({ whatsapp: v })} />
          </div>
        </div>

        <div className="bg-white rounded-xl border border-background-200 p-5">
          <h2 className="font-heading text-base font-semibold text-foreground-900 mb-4">Endereço</h2>
          <div className="space-y-4">
            <Field label="Endereço" value={info.address} onChange={(v) => update({ address: v })} />
            <div className="grid grid-cols-2 gap-4">
              <Field label="Cidade" value={info.city} onChange={(v) => update({ city: v })} />
              <Field label="Estado" value={info.state} onChange={(v) => update({ state: v })} />
            </div>
            <Field label="Link do Google Maps" value={info.googleMapsLink} onChange={(v) => update({ googleMapsLink: v })} />
          </div>
        </div>

        <div className="bg-white rounded-xl border border-background-200 p-5">
          <h2 className="font-heading text-base font-semibold text-foreground-900 mb-4">Atendimento</h2>
          <div className="space-y-4">
            <Field label="Horário de atendimento" value={info.businessHours} onChange={(v) => update({ businessHours: v })} />
            <Field label="Texto de atendimento" value={info.serviceText} onChange={(v) => update({ serviceText: v })} textarea />
          </div>
        </div>

        <div className="bg-white rounded-xl border border-background-200 p-5">
          <h2 className="font-heading text-base font-semibold text-foreground-900 mb-4">WhatsApp</h2>
          <div className="space-y-4">
            <Field label="Mensagem padrão do WhatsApp" value={info.whatsappDefaultMessage} onChange={(v) => update({ whatsappDefaultMessage: v })} textarea />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreInfoPage;